import React, { lazy, Suspense } from "react";
import AppHeader from "../components/header/index";
import { withStyles } from "@material-ui/core";
import GoldenLayoutComponent from "../layout/goldenLayoutComponent";
import {
  getLayoutConfiguration,
  registerComponents,
} from "../layout/layoutConfiguration";
import Grid from "@material-ui/core/Grid";
import { AppLoading } from "../loaders/loaders";
import { isEmpty } from "lodash";
import { getDataWithQueryString, postData } from "../api/componentAPIs";
import AuthService from "../auth/AuthService";
import { withUserProfile } from "../userProfile/userProfileContext";
import { compose } from "recompose";
import "../styles/customScrollbar.scss";

import SignalRClient from "../signalR/index";
import Events from "../utilities/EventEmitter";
import NotificationBanner from "../components/common/NotificationBanner";
import { withSnackbar } from "notistack";
import notificationConstant from "../components/modules/Settings/User/Notifications/constants";
import { withFeatureFlags } from "../userProfile/featureFlagsContext";
import { withAppConfig } from "../appConfigContext";

const RMAXMaintenance = lazy(() =>
  import("../components/common/RMAXMaintenance")
);

const styles = (theme) => ({
  layout: {
    backgroundColor: theme.AppBGColor,
    flexGrow: 1,
  },
  appContainer: {
    height: "100%",
    flexDirection: "column",
    flexWrap: "initial",
  },
  notification: {
    flexBasis: "unset",
    minHeight: 45,
  },
  appHeader: {
    height: "fit-content",
    flexBasis: "unset",
    minHeight: 45,
  },

  layoutContainer: {
    height: "100%",
    flexGrow: 1,
  },
});

class RouteRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserInfoLoaded: false,
      glEventHub: null,
      showNotificationBanner: false,
      notificationData: null,
      featureFlags: [],
      showMaintenanceDialog: false,
    };
  }
  updateglEventHub = (eventHubInstance) => {
    this.setState({
      glEventHub: eventHubInstance,
    });
  };
  componentDidMount() {
    if (this.props.userData && !this.props.userData.userProfile) {
      this.refreshUserInfo(undefined, undefined, false); //pass undefined here so that terminal is selected from session on hard refresh.
    } else {
      if (isEmpty(this.state.featureFlags)) {
        this.getEnabledFeatures(this.props.userData.userProfile.terminal.id);
      }
      this.setState({
        isUserInfoLoaded: true,
      });
    }
    this._isComponentMounted = true;
    Events.on("RefreshUserInfo", this.refreshUserInfo);
    Events.on("UpdateNotifications", this.getActiveNotifications);
  }

  componentWillUnmount() {
    Events.removeListener("RefreshUserInfo", this.refreshUserInfo);
    Events.removeListener("UpdateNotifications", this.getActiveNotifications);
    this._isComponentMounted = false;
  }
  refreshUserInfo = (
    terminalId,
    notificationMessage = null,
    refreshData = true
  ) => {
    this.getUserInfo(notificationMessage, refreshData, terminalId);
  };
  onNotificationBannerClose = () => {
    const reqObject = {
      notificationId: this.state.notificationData.notificationId,
    };
    postData("DisableNotification", reqObject).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        console.log(
          `Notification ${reqObject.notificationId} disabled for user ${this.props.userData.userProfile.userName}`
        );
      }
      this.getActiveNotifications();
    });
    this.setState({ showNotificationBanner: false });
  };
  getUserInfo=(notificationMessage,refreshData,terminalId=sessionStorage.getItem("selectedTerminal"))=>{
    getDataWithQueryString("GetUserInfo", `terminalId=${terminalId}`).then(response=>{
        if(response.status === 200 && response.data){
            const userDetails = response.data;
            
          this.getActiveNotifications();
          this.props.userData.updateUserProfile({
            userId: userDetails.userId,
            userName: AuthService.getUsername(),
            terminal: {
              id: userDetails.terminalId,
              location: {
                lat: userDetails.terminalLatitude,
                lng: userDetails.terminalLongitude,
              },
              name: userDetails.terminalName,
              code: userDetails.terminalCode,
              offset: userDetails.terminalOffset,
              address: userDetails.terminalAddress,
              dockCutOffTime: userDetails.dockCutOffTime
            },
            planDate: userDetails.planDate,
            startDate: userDetails.startDate,
            scenarioID: userDetails.scenarioId,
            scenarioName: userDetails.scenarioName,
            columnPref: JSON.parse(userDetails.userColumnPreference),
            theme: userDetails.theme,
            terminals: userDetails.terminals,
            isDefaultScenario: userDetails.isDefaultScenario,
            jobTitle: userDetails.jobTitle,
            roles: userDetails.roles,
            isAdmin: userDetails.roles.some((x) => x == "admin"),
            enableDispatch: userDetails.roles.some((role) =>
              ["dispatcher"].includes(role) // enable dispatch only for dispatchers for now
            ),
            geoJson: userDetails.geoJson || null,
          });
          this.getEnabledFeatures(userDetails.terminalId).then(() => {
            // Load UI after feature flags are loaded
            if (this._isComponentMounted) {
              this.setState({
                isUserInfoLoaded: true,
              });
            }
          });
          this.props.userData.toggleTheme(userDetails.theme);

          if (document) {
            document.title = `${userDetails.terminalCode} - RouteMAX`;
          }

          SignalRClient.disconnectFromHub(userDetails.scenarioId).then(() => {
            SignalRClient.connectToHub(
              userDetails.scenarioId,
              userDetails.terminalCode
            );
          });

          refreshData && Events.emit("RefreshIBStore");

          if (notificationMessage) {
            this.props.enqueueSnackbar(notificationMessage, {
              variant: "success",
            });
          }
        }
      }
    );
  };

  getActiveNotifications = () => {
    getDataWithQueryString("GetActiveNotificationForUser").then((response) => {
      if ([200, 204].includes(response?.status)) {
        const isMaintenanceNotification =
          response.data.type === notificationConstant.TYPE_MAINTENANCE;
        if (response.data) {
          this.setState({
            showNotificationBanner: !isMaintenanceNotification,
            notificationData: response.data,
            showMaintenanceDialog: isMaintenanceNotification,
          });
        } else {
          this.setState({
            showNotificationBanner: false,
            notificationData: null,
            showMaintenanceDialog: false,
          });
        }
      }
    });
  };

  getEnabledFeatures = (terminalId) => {
    return getDataWithQueryString(
      "GetEnabledFeaturesByTerminal",
      `terminalId=${terminalId}`
    ).then((response) => {
      if (response && response.status === 200 && response.data) {
        this.setState({
          featureFlags: response.data,
        });
        this.props.featureFlags.setFeatureFlags(response.data);
      }
    });
  };

  closeMaintenanceModal = () => {
    if (this.props.userData.userProfile.isAdmin) {
      this.setState({
        showMaintenanceDialog: false,
        notificationData: null,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    const { notificationData } = this.state;
    const { configJSON } = this.props;
    return (
      <div
        id="appContainer"
        className={`${classes.layout} ${
          theme === "dark" ? "darkTheme" : "lightTheme"
        } `}
      >
        {!this.state.isUserInfoLoaded ? (
          <AppLoading />
        ) : (
          <React.Fragment>
            <Grid container className={classes.appContainer}>
              {this.state.showNotificationBanner && (
                <Grid item xs={12} classes={{ item: classes.notification }}>
                  <NotificationBanner
                    data={this.state.notificationData}
                    onClose={this.onNotificationBannerClose}
                  />
                </Grid>
              )}
              <Grid item xs={12} classes={{ item: classes.appHeader }}>
                <AppHeader
                  path={this.props.match}
                  glEventHub={this.state.glEventHub}
                  featureFlags={this.state.featureFlags}
                />
              </Grid>
              <Grid item xs={12} classes={{ item: classes.layoutContainer }}>
                <GoldenLayoutComponent //config from simple react example: https://golden-layout.com/examples/#qZXEyv
                  htmlAttrs={{ style: { height: "100%", width: "100%" } }}
                  resize={this.state.showNotificationBanner}
                  path={this.props.match}
                  config={{
                    dimensions: {
                      borderWidth: 8,
                      headerHeight: 45.95,
                    },
                    settings: {
                      hasHeaders: true,
                      popoutWholeStack: true,
                      closePopoutsOnUnload: true,
                      showMaximiseIcon: true,
                      showCloseIcon: false,
                      reorderEnabled: false,
                    },

                    content: getLayoutConfiguration(this.props.match.url,configJSON),
                  }}
                  registerComponents={(myLayout) => {
                    registerComponents(
                      this.props.match.url,
                      myLayout,
                      configJSON
                    );
                  }}
                  updateEventHub={this.updateglEventHub}
                  featureFlags={this.state.featureFlags}
                />
              </Grid>
            </Grid>
            <Suspense fallback={<AppLoading />}>
              {this.state.showMaintenanceDialog && (
                <RMAXMaintenance
                  message={notificationData.message}
                  onClose={this.closeMaintenanceModal}
                  isClosable={this.props.userData.userProfile.isAdmin}
                  themeName={this.props.userData.userProfile.theme.themeName}
                />
              )}
            </Suspense>
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default compose(
  withUserProfile,
  withFeatureFlags,
  withSnackbar,
  withStyles(styles),
  withAppConfig,
)(RouteRenderer);
